import React, { Component } from "react";
import "react-drawer/lib/react-drawer.css";

import { Button, Col, Container, Row } from "reactstrap";
import VerticalLayoutDashboard from "../../components/VerticalLayoutDashboard/VerticalLayoutDashboard";
import ReactDrawer from "react-drawer";
import styled from "styled-components";
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { Redirect } from "react-router-dom"
import ModifiedMetaTags from '../../components/ModifiedMetaTags/index';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      position: "right",
    };

    this.onDrawerClose = this.onDrawerClose.bind(this);
    this.toggleRightDrawer = this.toggleRightDrawer.bind(this);
  }

  componentDidMount() {}

  toggleRightDrawer = () => {
    this.setState({ position: "right", open: !this.state.open });
  };

  onDrawerClose = () => {
    this.setState({ open: false });
  };

  render() {

    const { user_settings_loading, user_settings } = this.props

    const getContent = () => {
      if (user_settings_loading) return <span/>
      return <Redirect to={'/overview'} />
      // switch (user_settings?.dashboard_type) {
      //   case "quality_non_cohort_report":
      //     return <Redirect to={'/quality-report'} />
      //   case "quality_cohort_report":
      //     return <Redirect to={'/quality-cohort-report'} />
      //   case "top_management_report":
      //     return <Redirect to={'/top-management-report'} />
      //   default: return <span>Error!</span>
      // }
    }

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Dashboard | Mobihunter" />

          <Container fluid>

            {getContent()}

            {/*<StyledReactDrawer>*/}
            {/*  <ReactDrawer*/}
            {/*    open={this.state.open}*/}
            {/*    position={this.state.position}*/}
            {/*    onClose={this.onDrawerClose}*/}
            {/*    noOverlay={true}*/}
            {/*  >*/}
            {/*    <VerticalLayoutDashboard*/}
            {/*      status={this.state.open}*/}
            {/*      onClose={this.onDrawerClose}*/}
            {/*    />*/}
            {/*  </ReactDrawer>*/}
            {/*</StyledReactDrawer>*/}

            {/*<Row mb={2}>*/}
            {/*  <Col md={4}>*/}
            {/*    <div className="d-inline-block">*/}
            {/*      <h4*/}
            {/*        className="mb-0 font-size-16"*/}
            {/*        style={{*/}
            {/*          textTransform: "uppercase",*/}
            {/*          fontWeight: 600,*/}
            {/*        }}*/}
            {/*      >*/}
            {/*        Dashboard*/}
            {/*      </h4>*/}
            {/*    </div>*/}
            {/*  </Col>*/}
            {/*  <Col sm={8}>*/}
            {/*    <div className="text-sm-end">*/}
            {/*      <div>*/}
            {/*        <Button*/}
            {/*          type="button"*/}
            {/*          color="success"*/}
            {/*          className="btn-rounded"*/}
            {/*          onClick={this.toggleRightDrawer}*/}
            {/*          disabled={this.state.open}*/}
            {/*        >*/}
            {/*          Add dashboard*/}
            {/*        </Button>*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  </Col>   */}
            {/*</Row>*/}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const StyledReactDrawer = styled.div`
  div {
    .react-drawer-drawer {
      top: 0;
      right: 0;
      width: 400px !important;
      height: 100%;

    }
  }
`;

Dashboard.propTypes = {
  user_settings: PropTypes.object,
  user_settings_loading: PropTypes.bool,
}

const mapStateToProps = state => ({
  user_settings: state.User.user_settings,
  user_settings_loading: state.User.user_settings_loading,
})

export default connect(mapStateToProps, {})(Dashboard);
